import { computed, ref } from 'vue';
import { Form as AForm } from 'ant-design-vue/es/components';
import dayjs from 'dayjs';
export default {
  name: 'DateEditor',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'YYYY年MM月DD日'
    },
    postFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  emits: ['update:value', 'blur', 'focus'],
  setup(props, context) {
    const formItemContext = AForm.useInjectFormItemContext();
    const isFocused = ref(false);
    const text = computed(() => {
      const v = dayjs(props.value, props.postFormat);
      if (!v.isValid()) {
        return dayjs().format(props.format);
      }
      return v.format(props.format);
    });
    const date = computed(() => {
      const v = dayjs(props.value, props.postFormat);
      if (!v.isValid()) {
        return dayjs();
      }
      return v;
    });
    const handleBLur = e => {
      isFocused.value = false;
      context.emit('blur', e);
      formItemContext.onFieldBlur();
    };
    const handleFocus = e => {
      context.emit('focus', e);
      isFocused.value = true;
    };
    const handleUpdateValue = val => {
      let v = '';
      if (dayjs.isDayjs(val)) {
        v = val.format(props.postFormat);
      } else {
        const obj = dayjs(val, props.format);
        if (!obj.isValid()) {
          v = dayjs().format(props.postFormat);
        } else {
          v = obj.format(props.postFormat);
        }
      }
      context.emit('update:value', v);
    };
    return {
      handleBLur,
      handleFocus,
      handleUpdateValue,
      isFocused,
      text,
      date
    };
  }
};